// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './components/NavGroup/NavGroup';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = ({ isMinimized, isMobile = false, menuItems }) => {
  const navItems = menuItems.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} isMinimized={isMinimized} isMobile={isMobile}/>;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return < >{navItems}</>;
};

export default MenuList;
